@if ((isSuperAdminRoute$ | async) === false) {
  @if (shouldShowPoweredByVendasta$ | async) {
    <div class="powered-by-vendasta">
      <span class="powered-by-vendasta-text">Powered by</span>
      <img class="powered-by-vendasta-logo" src="{{ vendastaLogo }}" />
    </div>
  }
  <div class="logo">
    @if ((shouldShowAddLogo$ | async) === false) {
      @if ((shouldShowEditCapability$ | async) === true) {
        <div
          class="logo-container"
          [ngClass]="{ 'logo-edit': hoveringLogo }"
          (mouseenter)="hoveringLogo = true"
          (mouseleave)="hoveringLogo = false"
          (click)="editLogo()"
          >
          <ng-container *ngTemplateOutlet="justLogo"></ng-container>
          @if (hoveringLogo) {
            <mat-icon>create</mat-icon>
          }
        </div>
      } @else {
        <div class="logo-image-container">
          <img src="{{ whiteLabelLogoUrlDisplay$ | async }}" />
        </div>
      }
    } @else {
      @if (shouldShowAddLogo$ | async) {
        <a class="logo-placeholder" (click)="editLogo()">
          + {{ 'CUSTOMIZE_BRANDING.LOGO.TITLE' | translate }}
        </a>
      }
    }
  </div>
} @else {
  <div class="logo-image-container">
    <img src="{{ vendastaLogo }}" />
  </div>
}


<ng-template #justLogo>
  <div class="logo-image-container">
    <img src="{{ whiteLabelLogoUrlDisplay$ | async }}" />
  </div>
</ng-template>
